import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { db } from '../firebase/config';
import { doc, getDoc } from 'firebase/firestore';
import './Cart.css';

function Cart() {
  const navigate = useNavigate();
  const { cartItems, removeFromCart, updateQuantity, getCartTotal } = useCart();
  const [deliveryFee, setDeliveryFee] = useState(50);

  // Fetch delivery fee from settings
  useEffect(() => {
    const fetchDeliveryFee = async () => {
      try {
        const settingsRef = doc(db, 'settings', 'general');
        const settingsDoc = await getDoc(settingsRef);
        if (settingsDoc.exists()) {
          const fee = settingsDoc.data().deliveryFee;
          if (fee !== undefined && fee !== null) {
            const numericFee = Number(fee);
            if (!Number.isNaN(numericFee)) {
              setDeliveryFee(numericFee);
            }
          }
        }
      } catch (error) {
        console.error('Failed to fetch delivery fee', error);
      }
    };
    fetchDeliveryFee();
  }, []);

  const subtotal = getCartTotal();
  // Shipping will be calculated at checkout based on selected city
  const total = subtotal; // Total without shipping (shipping calculated at checkout)

  if (cartItems.length === 0) {
    return (
      <div className="cart-page">
        <div className="container">
          <div className="cart-empty">
            <svg width="120" height="120" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1">
              <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path>
              <line x1="3" y1="6" x2="21" y2="6"></line>
              <path d="M16 10a4 4 0 0 1-8 0"></path>
            </svg>
            <h2>Your cart is empty</h2>
            <p>Add some beautiful abayas to your cart</p>
            <button className="btn btn-primary" onClick={() => navigate('/shop')}>
              Continue Shopping
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="cart-page">
      <div className="container">
        <h1 className="cart-title">Shopping Cart</h1>

        <div className="cart-layout">
          <div className="cart-items">
            {cartItems.map((item, index) => (
              <div key={`${item.id}-${item.selectedSize}-${item.selectedLength}-${item.selectedColor}-${index}`} className="cart-item">
                <div
                  className="cart-item-image"
                  style={{
                    backgroundImage: `url(${item.image})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                  }}
                >
                  {item.badge && <span className="cart-item-badge">{item.badge}</span>}
                </div>

                <div className="cart-item-details">
                  <h3 className="cart-item-name">{item.name}</h3>
                  <div className="cart-item-options">
                    <span>Size: {item.selectedSize}</span>
                    <span>Length: {item.selectedLength || 'N/A'}</span>
                    {item.selectedColor && <span>Color: {item.selectedColor}</span>}
                  </div>
                  {item.notes && (
                    <div className="cart-item-notes">
                      <span className="notes-label">Notes:</span>
                      <span className="notes-text">{item.notes}</span>
                    </div>
                  )}
                  <p className="cart-item-price">{item.price.toFixed(2)} ر.ق</p>
                </div>

                <div className="cart-item-quantity">
                  <button
                    className="quantity-btn"
                    onClick={() =>
                      updateQuantity(
                        item.id,
                        item.selectedSize,
                        item.selectedColor,
                        item.selectedLength || '',
                        item.quantity - 1
                      )
                    }
                  >
                    −
                  </button>
                  <span className="quantity-value">{item.quantity}</span>
                  <button
                    className="quantity-btn"
                    onClick={() =>
                      updateQuantity(
                        item.id,
                        item.selectedSize,
                        item.selectedColor,
                        item.selectedLength || '',
                        item.quantity + 1
                      )
                    }
                  >
                    +
                  </button>
                </div>

                <div className="cart-item-total">
                  <p className="item-total-price">{(item.price * item.quantity).toFixed(2)} ر.ق</p>
                  <button
                    className="remove-btn"
                    onClick={() =>
                      removeFromCart(item.id, item.selectedSize, item.selectedColor, item.selectedLength || '')
                    }
                  >
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <polyline points="3 6 5 6 21 6"></polyline>
                      <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                      <line x1="10" y1="11" x2="10" y2="17"></line>
                      <line x1="14" y1="11" x2="14" y2="17"></line>
                    </svg>
                    Remove
                  </button>
                </div>
              </div>
            ))}
          </div>

          <div className="cart-summary">
            <h2 className="summary-title">Order Summary</h2>

            <div className="summary-row">
              <span>Subtotal ({cartItems.reduce((sum, item) => sum + item.quantity, 0)} items)</span>
              <span>{subtotal.toFixed(2)} ر.ق</span>
            </div>

            <div className="summary-row">
              <span>Shipping</span>
              <span style={{ fontSize: '0.85rem', color: '#6b7280', fontStyle: 'italic' }}>Calculated at checkout</span>
            </div>

            <div className="summary-divider"></div>

            <div className="summary-row summary-total">
              <span>Total</span>
              <span>{total.toFixed(2)} ر.ق</span>
            </div>

            <button className="btn btn-primary btn-checkout btn-checkout-regular" onClick={() => navigate('/checkout')}>
              Proceed to Checkout
            </button>

            <button className="btn btn-outline btn-continue" onClick={() => navigate('/shop')}>
              Continue Shopping
            </button>
          </div>
        </div>

        {/* Sticky Proceed to Checkout for Mobile */}
        <div className="cart-checkout-sticky">
          <button className="btn btn-primary btn-checkout-sticky" onClick={() => navigate('/checkout')}>
            Proceed to Checkout
          </button>
        </div>
      </div>
    </div>
  );
}

export default Cart;



